/**
 * Firebase web app configuration.
 *
 * These values are public by Firebase's design (the web "apiKey" identifies the
 * project; it is not a secret — security comes from Firebase Auth + backend
 * token verification), so they are safe to embed. Each field can still be
 * overridden at build time via a `VITE_FIREBASE_*` env var if you point the
 * extension at a different Firebase project.
 */
export const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY ?? 'AIzaSyBj-00719U9GXGGVjVf0XAth9QMLu0jUm4',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? 'prompt-library-backend.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID ?? 'prompt-library-backend',
  storageBucket:
    import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ?? 'prompt-library-backend.firebasestorage.app',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID ?? '462146818830',
  appId: import.meta.env.VITE_FIREBASE_APP_ID ?? '1:462146818830:web:ec5cfaf98d264059f7bd5f',
};
